exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".btn-filter[data-v-6f7174dc]{margin-top:20px}", "", {"version":3,"sources":["/app/src/components/reserves/Reserves.vue"],"names":[],"mappings":"AACA,6BACE,eAAiB,CAClB","file":"Reserves.vue","sourcesContent":["\n.btn-filter[data-v-6f7174dc] {\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6f7174dc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reserves/Reserves.vue
// module id = 493
// module chunks = 2